import React from 'react'
import Navbar from './Navbar'
const Projects = () => {
    return (
        <section className="resume-section" id="projects">
            <Navbar />
            <div className="resume-section-content">
                <h2 className="mb-5">Projects</h2>
                <ul className="fa-ul mb-0">
                    <li>
                        <span className="fa-li"><i className=""></i></span>
                        <h5>FinanceHouse</h5>
                        <p className='fst-italic text-success'>It is an Automation solution to the bank so that they can provide different services to their Customers (like Card transactions, Money Transfers, Mobile TOPUP's etc.)</p>
                    </li>
                    <li>
                        <span className="fa-li"><i className=""></i></span>
                        <h5>Dekhbhal</h5>
                        <p className='fst-italic text-success'>It is the online platform that provides services like
                    carpenter, plumber, Painter etc.</p>
                    </li>
                    <li>
                        <span className="fa-li"><i className=""></i></span>
                        <h5>WowPay</h5>
                        <p className='fst-italic text-success'>It is the online Payment platform that provides services like
                    card payments, mobile recharges, money transfer etc.Services like etisalat, muwaqif etc are integrated.</p>
                    </li>
                    <li>
                        <span className="fa-li"><i className=""></i></span>
                        <h5>KareKoin</h5>
                        <p className='fst-italic text-success'>
                            It is a reward-based system in which customers get coins on the base of different charities and later they can redeem those earned coins to get different services.
                            </p>
                    </li>
                    <li>
                        <span className="fa-li"><i className=""></i></span>
                        <h5>Cheffy</h5>
                        <p className='fst-italic text-success'>
                            It is an online food ordering platform. Morever on this platform customer can post a dish he wants to eat.He gets notified with details who can provide that customised dish.
                            </p>
                    </li>
                    <li>
                        <span className="fa-li"><i className=""></i></span>
                        <h5>ADPP</h5>
                        <p className='fst-italic text-success'>
                            It is an online du platform where acustomer can buy different services on Du with like calling plans. A customer can also buy differet mobile devices  with calling plans as well.
                            </p>
                    </li>
                    <li>
                        <span className="fa-li"><i className=""></i></span>
                        <h5>Middle-UAE</h5>
                        <p className='fst-italic text-success'>
                            It's global  payment integrator.
                            </p>
                    </li>
                    <li>
                        <span className="fa-li"><i className=""></i></span>
                        <h5>Pay-oll</h5>
                        <p className='fst-italic text-success'>
                            It's online platform with global reach allows its billers and merchants to offer different kinds of billing services from anywhere they are in the world. Whether it’s paying a mortgage, car rent bill, utility bill, credit card bill, car loan payment, or other telecom monthly bills; this will be integrated to link the biller, the merchant and the client/consumer in a single platform thereby earning the tag of a Global Bill Aggregator
                            </p>
                    </li>
                    <li>
                        <span className="fa-li"><i className=""></i></span>

                        <a href="https://sajidkhaki.github.io/weather-app/">
                            <h5>Weather App</h5>
                            <p className='fst-italic text-success'>
                                It's online weather web app, allowing us to check the weather update of any area.Created as a part of learning purpose  using react.
                            </p>
                        </a>
                    </li>
                    <li>
                        <span className="fa-li"><i className=""></i></span>
                        <a href=" https://sajidkhaki.github.io/React-Youtube">
                            <h5>Youtube App</h5>
                            <p className='fst-italic text-success'>
                                Mini Youtube web app, Created as a part of learning purpose  using react.
                            </p>
                        </a>
                    </li>
                    <li>
                        <span className="fa-li"><i className=""></i></span>
                        <a href="https://bookstore-sajidkhaki.vercel.app">
                            <h5>Book Store</h5>
                        </a>
                        <p className='fst-italic text-success'>
                            Mini Bookstore, Created as a part of learning purpose  using react.
                            </p>
                    </li>
                    <li>
                        <span className="fa-li"><i className=""></i></span>
                        <h5>FH-IO</h5>
                        <p className='fst-italic text-success'>
                            It is the finance house's venture, provides the global online payment system. It is a middleware that unifies around 20 APIs in a single system.
                            </p>
                    </li>
                </ul>
            </div>
        </section>
    )
}
export default Projects
